import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { UserService } from '../../services/api-services/user.service';
@Component({
  selector: 'app-confirm-select-user',
  templateUrl: './confirm-select-user.component.html',
  styleUrl: './confirm-select-user.component.scss'
})
export class ConfirmSelectUserComponent {
  isLoading = false;
  isRevert = false;
  constructor(
    public dialogRef: MatDialogRef<ConfirmSelectUserComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private userService: UserService,
    private toastr: ToastrService
  ) { }

  // confirm prescription
  confirmSelection() {
    this.isLoading = true;
    const payload = {
      user_id: this.data?.item?.patientId,
      prescription_id: this.data?.item?.rowId
    };
    this.userService.updateUserWithRcFaxes(payload).subscribe({
      next: (res: any) => {
        if (res && res?.body?.success) {
          this.isLoading = false;
          this.toastr.success(res.body.message);
          this.dialogRef.close(true);
        } else {
          this.isLoading = false;
          this.toastr.error(res.body.message || 'Failed to update additional coverage status');
          this.dialogRef.close(false);
        }
      }, error: (error) => {
        this.isLoading = false;
        console.error('error::', error);
        this.toastr.error('Error updating additional coverage status');
        this.dialogRef.close(false);
      }
    })
  } 
  
  // confirm dia prescription
  confirmDiaPrescription() {
    this.isLoading = true;
    const payload = {
      user_id: this.data?.item?.patientId,
      prescription_id: this.data?.item?.rowId
    };
    this.userService.updateDiaUserFaxes(payload).subscribe({
      next: (res: any) => {
        if (res && res?.body?.success) {
          this.isLoading = false;
          this.toastr.success(res.body.message);
          this.dialogRef.close(true);
        } else {
          this.isLoading = false;
          this.toastr.error(res.body.message || 'Failed to update additional coverage status');
          this.dialogRef.close(false);
        }
      }, error: (error) => {
        this.isLoading = false;
        console.error('error::', error);
        this.toastr.error('Error updating additional coverage status');
        this.dialogRef.close(false);
      }
    })
  }

  // revert prescription
  confirmRevertSelection() {
    const tenant = localStorage.getItem('tenant');
    const payload = {
      prescription_id: this.data?.item?.prescriptionId,
      db_tenant: tenant
    };
    this.isRevert = true;
    this.userService.updateRevertPres(payload).subscribe({
      next: (res: any) => {
        if (res && res?.body?.success) {
          this.toastr.success(res.body.message);
          this.isRevert = false;
          this.dialogRef.close(true);
        } else {
          this.toastr.error(res.body.message || 'Failed to update additional coverage status');
          this.isRevert = false;
          this.dialogRef.close(false);
        }
      }, error: (error) => {
        console.error('error::', error);
        this.isRevert = false;
        this.toastr.error('Error updating additional coverage status');
        this.dialogRef.close(false);
      }
    })
  }

  // revert dialogue prescription
  confirmRevertDialogueSelection() {
    const tenant = localStorage.getItem('tenant');
    const payload = {
      prescription_id: this.data?.item?.prescriptionId,
      db_tenant: tenant
    };
    this.isRevert = true;
    this.userService.updateRevertDialoguePres(payload).subscribe({
      next: (res: any) => {
        if (res && res?.body?.success) {
          this.toastr.success(res.body.message);
          this.isRevert = false;
          this.dialogRef.close(true);
        } else {
          this.toastr.error(res.body.message || 'Failed to update additional coverage status');
          this.isRevert = false;
          this.dialogRef.close(false);
        }
      }, error: (error) => {
        console.error('error::', error);
        this.isRevert = false;
        this.toastr.error('Error updating additional coverage status');
        this.dialogRef.close(false);
      }
    })
  }

  closeDialog() {
    this.dialogRef.close();
  }
}
